import React, { useState } from 'react';

function dateTime() {

  const date = new Date();
  let ampm = "AM"
  if (date.getHours()>11 ){
    ampm = "PM";
  }
  let hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is zero-based
  const day = String(date.getDate()).padStart(2, '0');
  if (hours >12){ hours = hours-12;}
  if (hours === 0) { hours = 12;}

  return `${year}/${month}/${day} ${hours}:${minutes}${ampm}`;
}

const Footer = () => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <footer id="Footer">
        <div id='FooterItem'>
          <div id ='FooterPadding'>Padding</div>
          <a href="https://uh.edu/cbl/" rel="noreferrer" target="_blank">
            <img src={require('../img/logo_cbl.png')} alt="logo_cbl" height={"100px"}/>
          </a>
          <div id='Footer-logo-text'>
            {"Released 2025-12-22 16:00 PM"} © AI-SNIPS Project ({process.env.REACT_APP_VERSION})
          </div>
        </div>
        <div id='FooterItem'>
          <h2>
            Contact
          </h2>
          <p>
            Computational Biomedicine Lab
            <br/>
            c/o Ioannis A Kakadiaris
            <br/>
            University of Houston
            <br/>
            4349 MLK Blvd., Rm 322
            <br/>
            Houston, TX 77204-6022
          </p>
        </div>
        <div id='FooterItem'>
          <h2>
            Support
          </h2>
          <p>
          AI-SNIPS Support information
          <br/>
          Email: <a
            href="mailto:info@ai-snips.io"
            style={{ color: 'white', textDecoration: isHovered ? 'underline' : 'none' }}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            info@ai-snips.io
          </a>
          </p>
        </div>
      {/* <h1 className="sandbox__footer">UH CBL</h1> */}
      {/* <a
        className="sandbox__footer__link"
        href="https://github.com/davidjerleke/embla-carousel"
      >
        <svg
          className="sandbox__footer__link__svg"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
        >
          <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
        </svg>
        <span className="sandbox__footer__link__text">Visit on GitHub</span>
      </a> */}
    </footer>
  );
};

export default Footer;
